var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<warning-notification ng-if=\"servicePage\"></warning-notification> <div nav-top ng-if=\"!servicePage && !yasno\"></div> <div frame-nav-top ng-if=\"servicePage && !yasno && !hideHeader\"></div> <div ng-if=\"$root.STATE_GOIN\" style=\"position: relative;top:0;left:0;width:100%;height:94vh;z-index: 100000000\" ct-spinner=\"$root.STATE_GOIN\"></div> <main role=\"main\" id=\"main-content\"> <div ui-view ng-hide=\"$root.STATE_GOIN\"></div> </main>   <div id=\"sr-live-region\" class=\"sr-only\" role=\"status\" aria-live=\"polite\" aria-atomic=\"true\"></div> <div id=\"sr-alert-region\" class=\"sr-only\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\"></div>";
ngModule.run(["$templateCache",function(c){c.put("portal/app/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/index.html
 ** module id = 577
 ** module chunks = 1
 **/